'use strict';

var $isNaN = require('./isNaN');

/** @type {import('./isFinite')} */
module.exports = function isFinite(x) {
	return (typeof x === 'number' || typeof x === 'bigint')
        && !$isNaN(x)
        && x !== Infinity
        && x !== -Infinity;
};




/*****************
 ** WEBPACK FOOTER
 ** ./~/math-intrinsics/isFinite.js
 ** module id = 666
 ** module chunks = 0
 **/